export * as experiences from '@wix/auto_sdk_table-reservations_experiences/meta';
export * as reservations from '@wix/auto_sdk_table-reservations_reservations/meta';
export * as reservationLocations from '@wix/auto_sdk_table-reservations_reservation-locations/meta';
export * as timeSlots from '@wix/auto_sdk_table-reservations_time-slots/meta';
